import type { Template } from "@/types";

export const PO_05_H1_V4: Template[] = [
{
    id: "po-05-h1v4-01",
    name: "PO 01 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 39, y: 239, width: 490, height: 377, rotation: 0, imageRotation: 0 },
            { id: "2", x: 690, y: 156, width: 159, height: 268, rotation: 0, imageRotation: 0 },
            { id: "3", x: 690, y: 432, width: 159, height: 267, rotation: 0, imageRotation: 0 },
            { id: "4", x: 857, y: 156, width: 158, height: 268, rotation: 0, imageRotation: 0 },
            { id: "5", x: 857, y: 432, width: 158, height: 267, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-05-h1v4-02",
    name: "PO 02 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 39, y: 239, width: 490, height: 377, rotation: 0, imageRotation: 0 },
        { id: "2", x: 613, y: 116, width: 348, height: 620, rotation: 0, imageRotation: 0 },
        { id: "3", x: 969, y: 116, width: 121, height: 202, rotation: 0, imageRotation: 0 },
        { id: "4", x: 969, y: 326, width: 121, height: 201, rotation: 0, imageRotation: 0 },
        { id: "5", x: 969, y: 535, width: 121, height: 201, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-03",
    name: "PO 03 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 55, y: 122, width: 458, height: 342, rotation: 0, imageRotation: 0 },    
        { id: "2", x: 55, y: 472, width: 148, height: 261, rotation: 0, imageRotation: 0 },
        { id: "3", x: 211, y: 472, width: 147, height: 261, rotation: 0, imageRotation: 0 },
        { id: "4", x: 366, y: 472, width: 147, height: 261, rotation: 0, imageRotation: 0 },
        { id: "5", x: 649, y: 95, width: 406, height: 651, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-04",
    name: "PO 04 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 49, y: 188, width: 256, height: 477, rotation: 0, imageRotation: 0 },
        { id: "2", x: 313, y: 188, width: 207, height: 154, rotation: 0, imageRotation: 0 },
        { id: "3", x: 313, y: 350, width: 207, height: 315, rotation: 0, imageRotation: 0 },
        { id: "4", x: 623, y: 236, width: 224, height: 382, rotation: 0, imageRotation: 0 },
        { id: "5", x: 855, y: 236, width: 223, height: 382, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-05",
    name: "PO 05 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_05.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 58, y: 236, width: 224, height: 382, rotation: 0, imageRotation: 0 },
        { id: "2", x: 290, y: 236, width: 223, height: 382, rotation: 0, imageRotation: 0 },
        { id: "3", x: 616, y: 188, width: 257, height: 477, rotation: 0, imageRotation: 0 },
        { id: "4", x: 881, y: 188, width: 207, height: 315, rotation: 0, imageRotation: 0 },
        { id: "5", x: 881, y: 511, width: 207, height: 154, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-06",
    name: "PO 06 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 88, y: 101, width: 390, height: 652, rotation: 0, imageRotation: 0 },
        { id: "2", x: 616, y: 385, width: 471, height: 344, rotation: 0, imageRotation: 0 },
        { id: "3", x: 616, y: 125, width: 152, height: 252, rotation: 0, imageRotation: 0 },
        { id: "4", x: 776, y: 125, width: 152, height: 252, rotation: 0, imageRotation: 0 },
        { id: "5", x: 936, y: 125, width: 151, height: 252, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-07",
    name: "PO 07 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 26, y: 141, width: 161, height: 282, rotation: 0, imageRotation: 0 },
        { id: "2", x: 26, y: 431, width: 161, height: 282, rotation: 0, imageRotation: 0 },
        { id: "3", x: 195, y: 141, width: 161, height: 282, rotation: 0, imageRotation: 0 },
        { id: "4", x: 195, y: 431, width: 161, height: 282, rotation: 0, imageRotation: 0 },
        { id: "5", x: 364, y: 141, width: 745, height: 572, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-08",
    name: "PO 08 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 226, width: 538, height: 403, rotation: 0, imageRotation: 0 },
        { id: "2", x: 546, y: 226, width: 229, height: 403, rotation: 0, imageRotation: 0 },
        { id: "3", x: 907, y: 226, width: 229, height: 403, rotation: 0, imageRotation: 0 },
        { id: "4", x: 783, y: 226, width: 116, height: 198, rotation: 0, imageRotation: 0 },
        { id: "5", x: 783, y: 432, width: 116, height: 197, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-09",
    name: "PO 09 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 226, width: 539, height: 403, rotation: 0, imageRotation: 0 },
        { id: "2", x: 547, y: 226, width: 229, height: 403, rotation: 0, imageRotation: 0 },
        { id: "3", x: 784, y: 226, width: 228, height: 403, rotation: 0, imageRotation: 0 },
        { id: "4", x: 1020, y: 226, width: 116, height: 198, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1020, y: 432, width: 116, height: 197, rotation: 0, imageRotation: 0 }
    ],
}
];